import axios from 'axios'
import { sanitize } from '@/js/utils/sanitize'
import { randomBaseUrl } from '@/js/utils/randomBaseUrl'

export const delegateSequence = params => new Promise((resolve, reject) => {

  let answerid = params.answerid ? sanitize(params.answerid) : null
  let collaboratorid = params.collaboratorid ? sanitize(params.collaboratorid) : null
  let key = params.key ? sanitize(params.key) : null
  let path = params.path ? sanitize(params.path) : null
  let sequenceid = params.sequenceid ? sanitize(params.sequenceid) : null

  answerid = answerid ? encodeURIComponent(answerid) : null
  collaboratorid = collaboratorid ? encodeURIComponent(collaboratorid) : null
  key = key ? encodeURIComponent(key) : null
  path = path ? encodeURIComponent(path) : null
  sequenceid = sequenceid ? encodeURIComponent(sequenceid) : null

  let uri = '?options=json'
  uri = answerid &&
        answerid !== null &&
        answerid !== 'null' ? `${uri}&answerid=${answerid}` : uri
  uri = collaboratorid &&
        collaboratorid !== null &&
        collaboratorid !== 'null' ? `${uri}&collaboratorid=${collaboratorid}` : uri
  uri = key &&
        key !== null &&
        key !== 'null' ? `${uri}&key=${key}` : uri
  uri = path &&
        path !== null &&
        path !== 'null' ? `${uri}&path=${path}` : uri
  uri = sequenceid &&
        sequenceid !== null &&
        sequenceid !== 'null' ? `${uri}&sequenceid=${sequenceid}` : uri

  axios.get(randomBaseUrl(0, 3) + process.env.VUE_APP_DELEGATE_SHOW_SEQUENCE_ENDPOINT + uri)
    .then(response => {
      resolve(response.data.answer)
    })
    .catch(error => {
      reject(error)
    })
})
